import type { NextPage } from "next";
import styled from "styled-components";
import { parseCookies } from "nookies";
import CredentialsHomeContainer from "core/credentials/UI/CredentialsHomeContainer";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const DashboardProfilePage: NextPage = () => {
  const { userRefId } = parseCookies();

  return (
    <Container>
      {userRefId && <CredentialsHomeContainer userRefId={userRefId} />}
    </Container>
  );
};

export default DashboardProfilePage;
